// @flow
// Externals
import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import "./MobilePage.scss";
import questionAnimation from "./Animations";
import Question from "./Question";

const MobilePage = ({ questionData } /*: Props */) /*: any */ => {
	const answers = useSelector((state) => state.answers);
	const questionAnswer = useMemo(
		() => answers[questionData.id],
		[answers, questionData],
	);

	const Animation = useMemo(() => {
		return questionAnimation[questionData.id];
	}, [questionData]);

	return (
		<div className={"question-container question-" + questionData.id}>
			<Question question={questionData} />
			<div
				className="mobile-page-animations"
				style={{
					position: "relative",
					transform: "translateX(-2rem)",
					width: "100vw",
					display: "flex",
					justifyContent: "center",
					minHeight: "70%",
					alignItems: "flex-end",
				}}
			>
				<Animation
					value={questionAnswer.answer.map((a) => a.text).join()}
					options={questionData.answers.map((answer) => answer.text)}
				/>
			</div>
		</div>
	);
};

// Exports
export default MobilePage;
